<template>
	<j-card v-if="resource" class="xs-12 p4 bg5">
		<resource-detail-input-field
			componentName="j-base-input-text"
			class="mb4"
			:label="$t('name')"
			name="name"
			v-model="resource.name"
			@blur="handleFieldUpdate('name')"
		/>
		<resource-detail-input-field
			componentName="j-base-input-long-text"
			class="mb4"
			:label="$t('description')"
			name="description"
			v-model="resource.description"
			@blur="handleFieldUpdate('description')"
		/>
		<resource-detail-input-field
			componentName="j-base-input-text"
			class="mb4"
			:label="$t('version')"
			name="version"
			v-model="resource.version"
			@blur="handleFieldUpdate('version')"
		/>
		<resource-detail-input-field
			componentName="input-categories-list"
			class="mb4"
			size="xsmall"
			:label="$t('categories')"
			name="featured"
			v-model="resource.categories"
			@input="handleFieldUpdate('categories')"
		/>
	</j-card>
</template>

<script>
import ResourceDetailInputField from "./ResourceDetailInputField"
import JCard from "@/components/JCard"

import api from "@/api/gql.js"

import queries from "../utils/queries.js"

export default {
	components: {
		ResourceDetailInputField,
		JCard
	},

	props: {
		resource: Object,

		selectedLocale: String
	},

	data() {
		return {
			form: {
				name: null,
				description: null,
				version: null,
				categories: null
			},
			schema: null
		}
	},

	computed: {
		computedCategories() {
			return this.course?.categories?.map(item => {
				return {
					name: item,
					value: item
				}
			})
		},

		courseId() {
			return this.course.id
		}
	},

	methods: {
		onInputSchema(payload) {
			this.schema = payload
		},

		async handleFieldUpdate(field) {
			if (!this.resource[field]) return
			let apiKey, query, variables
			// Upsert l10n key if name or description ; update course if lenght or categories
			if (field === "name" || field === "description") {
				variables = {
					l10n: {
						key: `courses-${this.resource?.id}-${field}`,
						locale: this.selectedLocale,
						value: this.resource[field]
					}
				}
				apiKey = "upsertL10n"
				query = queries.upsertL10n
			} else {
				variables = {
					id: this.resource?.id,
					input: {
						[field]: this.resource[field]
					}
				}
				apiKey = "updateCourse"
				query = queries.updateCourse
			}

			const res = await api({ query, variables })
			this.isLoading = false

			if (res?.data[apiKey]?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: this.$t("errors.general")
					}
				})
				return
			}

			this.$emit("resource:updated")
		}
	}
}
</script>
